import { render, staticRenderFns } from "./RegistrosImportacao.vue?vue&type=template&id=5aa4ac15&scoped=true&"
import script from "./RegistrosImportacao.vue?vue&type=script&lang=js&"
export * from "./RegistrosImportacao.vue?vue&type=script&lang=js&"
import style0 from "./RegistrosImportacao.vue?vue&type=style&index=0&id=5aa4ac15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa4ac15",
  null
  
)

export default component.exports